import React from 'react';
import { Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
}

export const SolarBubbleChatIcon: React.FC<IconProps> = ({ size = 32 ,color}) => {
  const COLOR = color || '#7E74E4';
  return(
    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">

      <Path
        d="M18.6667 9.42701C17.0977 8.51944 15.2762 8 13.3333 8C7.44229 8 2.66667 12.7756 2.66667 18.6667C2.66667 20.373 3.06732 21.9857 3.77969 23.416C3.969 23.796 4.03201 24.2305 3.92226 24.6407L3.28694 27.0151C3.01115 28.0459 3.95415 28.9888 4.9849 28.7131L7.35934 28.0777C7.76953 27.968 8.20395 28.031 8.58403 28.2203C10.0143 28.9327 11.627 29.3333 13.3333 29.3333C19.2244 29.3333 24 24.5577 24 18.6667C24 16.7238 23.4806 14.9023 22.573 13.3333"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M23.9994 19.3361C24.088 19.2991 24.1759 19.2608 24.263 19.221C24.7458 19.0004 25.2874 18.918 25.8002 19.0551L26.4349 19.225C27.7233 19.5697 28.9021 18.391 28.5573 17.1025L28.3875 16.4678C28.2503 15.9551 28.3328 15.4134 28.5533 14.9306C29.0538 13.835 29.3327 12.6169 29.3327 11.3337C29.3327 9.63488 28.8439 8.05026 27.9994 6.71274M12.666 7.99446C13.9735 4.86564 17.063 2.66699 20.666 2.66699C22.3842 2.66699 23.9856 3.16699 25.3327 4.02942"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M8.68973 18.667H8.70173M13.344 18.667H13.356M17.9987 18.667H18.0107"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
